/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../views/cache_date/cache_date.component.ngfactory";
import * as i2 from "../views/cache_date/cache_date.component";
import * as i3 from "../views/cache_date/cache_date.service";
import * as i4 from "../lib/EventsService";
import * as i5 from "./index.component";
var styles_IndexComponent = [];
var RenderType_IndexComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_IndexComponent, data: {} });
export { RenderType_IndexComponent as RenderType_IndexComponent };
export function View_IndexComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "cache-date", [], null, null, null, i1.View_CacheDateComponent_0, i1.RenderType_CacheDateComponent)), i0.ɵdid(1, 245760, null, 0, i2.CacheDateComponent, [i3.CacheDateService, i4.EventsService], null, null), (_l()(), i0.ɵted(-1, null, [" \u041F\u0443\u0442\u044C \u043E\u0441\u0438\u043B\u0438\u0442 \u0438\u0434\u0443\u0449\u0438\u0439! "]))], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_IndexComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "index-page", [], null, null, null, View_IndexComponent_0, RenderType_IndexComponent)), i0.ɵdid(1, 49152, null, 0, i5.IndexComponent, [], null, null)], null, null); }
var IndexComponentNgFactory = i0.ɵccf("index-page", i5.IndexComponent, View_IndexComponent_Host_0, {}, {}, []);
export { IndexComponentNgFactory as IndexComponentNgFactory };
